import {
  ArrowRightIcon,
  CheckCircleIcon,
  LockClosedIcon,
  XMarkIcon
} from "@heroicons/react/24/outline";
import React, { useEffect, useRef } from "react";
import { comparedYearData } from "../adminData";

import { Link, useNavigate } from "react-router-dom";
import DashboardAdminCalendar from "../../../calendar/DashboardAdminCalendar";
import GreenChartSvg from "../svgIcons/GreenChartSvg";
import RedChartSvg from "../svgIcons/RedChartSvg";

const OwnerMetricsData = ({
  metricsData,
  handleClose,
  handleOpen,
  calendarOpen,
  setCalendarOpen,
  handleDateFilter,
  selectRange,
  setSelectRange,
  calendarData,
  selectedCalendarFilter,
  calendarFilterChange,
  selectedCompareFilter,
  compareFilterChange,
  handleCalendarChange,
}) => {
  const navigate = useNavigate();
  const calendarRef = useRef(null)

  const handleOutsideClick = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setCalendarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleCreditRequest = (type) => {
    if (type === "new") {
      navigate("/admin-dashboard/users", {
        state: {
          statusTitle: "pending",
        },
      });
    } else if (type === "credit") {
      navigate("/admin-dashboard/credit-requests");
    }
  };

  return (
    <div className="p-5 border border-[#EBEFF3] rounded-md bg-white">
      <div className="mb-6" ref={calendarRef}>
        <DashboardAdminCalendar
          calendarFilter={calendarData}
          compareFilter={comparedYearData}
          selectedCalendarFilter={selectedCalendarFilter}
          calendarFilterChange={calendarFilterChange}
          selectedCompareFilter={selectedCompareFilter}
          compareFilterChange={compareFilterChange}
          handleCalendarChange={handleCalendarChange}
          setSelectRange={setSelectRange}
          selectRange={selectRange}
          handleDateFilter={handleDateFilter}
          calendarOpen={calendarOpen}
          setCalendarOpen={setCalendarOpen}
          handleOpen={handleOpen}
          handleClose={handleClose}
        />
      </div>
      <div className="bg-[#F1F4F6] rounded-md py-5 px-4 grid grid-cols-12 gap-2.5 mb-[30px]">
        <div className="bg-white border border-[#EBEFF3] px-[14px] pt-6 pb-[30px] col-span-12 sm:col-span-6 md:col-span-4 rounded-md">
          <CheckCircleIcon className="w-11 h-11 rounded-md p-[10px] flex items-center justify-center mb-3 bg-[#16CA7C] text-white" />
          <span className="text-xs leading-[160%] text-[#485868] font-bold uppercase mb-1">
            current
          </span>
          <h6 className="text-sm font-bold leading-[160%] text-customGray mb-3 capitalize">
            successful matches
          </h6>
          <div className="flex items-center gap-2.5">
            <span className="text-[22px] leading-[180%] font-black text-customGray">
              {metricsData?.successful_matches}
            </span>
            <div className="w-[1px] h-6 bg-[#BEC2C5]"></div>
            <div className="flex items-center gap-1.5">
              {metricsData?.successful_matches_change?.startsWith("-") ? (
                <RedChartSvg />
              ) : (
                <GreenChartSvg />
              )}
              <span
                className={`text-sm font-bold leading-[180%] ${
                  metricsData?.successful_matches_change?.startsWith("-")
                    ? "text-[#EF2121]"
                    : "text-[#16CA7C]"
                }`}
              >
                {metricsData?.successful_matches_change}
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white border border-[#EBEFF3] px-[14px] pt-6 pb-[30px] col-span-12 sm:col-span-6 md:col-span-4 rounded-md">
          <LockClosedIcon className="w-11 h-11 rounded-md p-[10px] flex items-center justify-center mb-3 bg-[#EE6D24] text-white" />
          <span className="text-xs leading-[160%] text-[#485868] font-bold uppercase mb-1">
            current
          </span>
          <h6 className="text-sm font-bold leading-[160%] text-customGray mb-3 capitalize">
            pending matches
          </h6>
          <div className="flex items-center gap-2.5">
            <span className="text-[22px] leading-[180%] font-black text-customGray">
              {metricsData?.pending_matches}
            </span>
            <div className="w-[1px] h-6 bg-[#BEC2C5]"></div>
            <div className="flex items-center gap-1.5">
              {metricsData?.pending_matches_change?.startsWith("-") ? (
                <RedChartSvg />
              ) : (
                <GreenChartSvg />
              )}
              <span
                className={`text-sm font-bold leading-[180%] ${
                  metricsData?.pending_matches_change?.startsWith("-")
                    ? "text-[#EF2121]"
                    : "text-[#16CA7C]"
                }`}
              >
                {metricsData?.pending_matches_change}
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white border border-[#EBEFF3] px-[14px] pt-6 pb-[30px] col-span-12 sm:col-span-6 md:col-span-4 rounded-md">
          <XMarkIcon className="w-11 h-11 rounded-md p-[10px] flex items-center justify-center mb-3 bg-[#EF2121] text-white" />
          <span className="text-xs leading-[160%] text-[#485868] font-bold uppercase mb-1">
            current
          </span>
          <h6 className="text-sm font-bold leading-[160%] text-customGray mb-3 capitalize">
            failed matches
          </h6>
          <div className="flex items-center gap-2.5">
            <span className="text-[22px] leading-[180%] font-black text-customGray">
              {metricsData?.failed_matches}
            </span>
            <div className="w-[1px] h-6 bg-[#BEC2C5]"></div>
            <div className="flex items-center gap-1.5">
              {metricsData?.failed_matches_change?.startsWith("-") ? (
                <RedChartSvg />
              ) : (
                <GreenChartSvg />
              )}
              <span
                className={`text-sm font-bold leading-[180%] ${
                  metricsData?.failed_matches_change?.startsWith("-")
                    ? "text-[#EF2121]"
                    : "text-[#16CA7C]"
                }`}
              >
                {metricsData?.failed_matches_change}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-between mb-[14px]">
          <h6 className="text-base font-bold leading-[180%] text-[#04091E]">
            Team Metrics
          </h6>
        </div>
        <div className="grid grid-cols-12 gap-4">
          <Link
          to="/admin-dashboard/users"
            className="team-matrics-card col-span-12 sm:col-span-6 py-[14px] px-5 border border-[#F1F4F6] rounded-md flex items-center justify-between cursor-pointer"
            onClick={() => handleCreditRequest("new")}
          >
            <div className="flex items-center gap-[14px]">
              <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                {metricsData?.new_enrollments ?? "-"}
              </span>
              <div>
                <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                  new enrollments
                </h6>
                <div className="flex items-center gap-1.5">
                  {metricsData?.new_enrollments_change?.startsWith("-") ? (
                    <RedChartSvg />
                  ) : (
                    <GreenChartSvg />
                  )}
                  <span
                    className={`text-sm font-bold leading-[180%] ${
                      metricsData?.new_enrollments_change?.startsWith("-")
                        ? "text-[#EF2121]"
                        : "text-[#16CA7C]"
                    }`}
                  >
                    {metricsData?.new_enrollments_change}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <ArrowRightIcon className="w-6 h-6 text-customGray" />
            </div>
          </Link>
          <Link
          to="/admin-dashboard/credit-requests"
            className="team-matrics-card col-span-12 sm:col-span-6 py-[14px] px-5 border border-[#F1F4F6] rounded-md flex items-center justify-between cursor-pointer"
            onClick={() => handleCreditRequest("credit")}
          >
            <div className="flex items-center gap-[14px]">
              <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                {metricsData?.credit_requests ?? "-"}
              </span>
              <div>
                <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                  credit requests
                </h6>
                <div className="flex items-center gap-1.5">
                  {metricsData?.credit_requests_change?.startsWith("-") ? (
                    <RedChartSvg />
                  ) : (
                    <GreenChartSvg />
                  )}
                  <span
                    className={`text-sm font-bold leading-[180%] ${
                      metricsData?.credit_requests_change?.startsWith("-")
                        ? "text-[#EF2121]"
                        : "text-[#16CA7C]"
                    }`}
                  >
                    {metricsData?.credit_requests_change}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <ArrowRightIcon className="w-6 h-6 text-customGray" />
            </div>
          </Link>
          <div className="team-matrics-card col-span-12 sm:col-span-6 py-[14px] px-5 border border-[#F1F4F6] rounded-md flex items-center justify-between cursor-pointer">
            <div className="flex items-center gap-[14px]">
              <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                {metricsData?.support_tickets ?? "-"}
              </span>
              <div>
                <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                  support tickets
                </h6>
                <div className="flex items-center gap-1.5">
                  {metricsData?.support_tickets_change?.startsWith("-") ? (
                    <RedChartSvg />
                  ) : (
                    <GreenChartSvg />
                  )}
                  <span
                    className={`text-sm font-bold leading-[180%] ${
                      metricsData?.support_tickets_change?.startsWith("-")
                        ? "text-[#EF2121]"
                        : "text-[#16CA7C]"
                    }`}
                  >
                    {metricsData?.support_tickets_change}
                  </span>
                </div>
              </div>
            </div>
            <div>
              {/* <ArrowRightIcon className="w-6 h-6 text-customGray" /> */}
            </div>
          </div>
          <div className="team-matrics-card col-span-12 sm:col-span-6 py-[14px] px-5 border border-[#F1F4F6] rounded-md flex items-center justify-between cursor-pointer">
            <div className="flex items-center gap-[14px]">
              <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                {metricsData?.days_to_first_lead ?? "-"}
              </span>
              <div>
                <h6 className="text-sm font-medium leading-[160%] text-customGray">
                  Days to First Lead
                </h6>
                <div className="flex items-center gap-1.5">
                  {metricsData?.days_to_first_lead_change?.startsWith("-") ? (
                    <RedChartSvg />
                  ) : (
                    <GreenChartSvg />
                  )}
                  <span
                    className={`text-sm font-bold leading-[180%] ${
                      metricsData?.days_to_first_lead_change?.startsWith("-")
                        ? "text-[#EF2121]"
                        : "text-[#16CA7C]"
                    }`}
                  >
                    {metricsData?.days_to_first_lead_change}
                  </span>
                </div>
              </div>
            </div>
            <div>
              {/* <ArrowRightIcon className="w-6 h-6 text-customGray" /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerMetricsData;
